import {getSizes, getDivSize, mixArray, getNumbers, generateSegmentArray } from "./Segment.data";
import React, { useState, useRef, useEffect} from "react";
import { 
    animationDurationToShowscoresPopup,
    animationDurationToShowQWrongAnswer
} from "../../../config";
import Sound from '../../../components/global/Sound';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { updateStorage } from "../../../hooks/useStorage";
import { updateGameStorage } from "../../../hooks/useGameStorage";
import * as amplitude from '@amplitude/analytics-browser';
import { useUpdateReduxState } from "../../../hooks/useUpdateReduxState";
import { gameId } from "../../../hooks/getGameId";


export const Segment = ({state, update, handleOpenScore, handleUpdateProgress, answerSound, level, handleTimer, point, hint:hintOn, subscription}) => {
    const {name, gameName} = useParams();
    const size = level==='beginner' ? 5 : 10;
    const numbers = useRef(getNumbers(level, gameName.includes("asc") ? 1 : -1));
    const data = useRef(generateSegmentArray(numbers.current, level));
    const [result, setResult] = useState(mixArray(data.current, level));
    const [clickedIndex, setClickedIndex] = useState();
    const [rightAnswers, setRightAnswers] = useState([]);
    const soundRef = useRef();
    const score = useRef(0);

    const updateState = useUpdateReduxState();

    useEffect(()=>{
        !update && setRightAnswers([numbers.current[0]]);
    }, [update]);

    
    useEffect(()=>{
        if (typeof(level) === "number") return;
        amplitude.track(`${name+"_"+gameName.replace("_", " ")+"_"+level+"_start"}`);
    }, []);

    const handleClick = (item, index) => {
        if (item===(rightAnswers[rightAnswers.length-1]+1*(gameName.includes("asc") ? 1 : -1))) {
            soundRef.current && soundRef.current.play();
            setRightAnswers([...rightAnswers, item]);
            setClickedIndex('');
        } else {
            setClickedIndex(index);
            setTimeout(()=>{
                setClickedIndex('');
            }, animationDurationToShowQWrongAnswer*1000);
        }
        setHint(0);
    }

    useEffect(()=>{
        if (rightAnswers.length === size) {
         score.current += point[level];
         if (!subscription) {
            updateStorage(point[level]);
         }
         
         if (subscription) {
            updateState({
                userId: localStorage.getItem('user'),
                profileId: JSON.parse(localStorage.getItem('profile'))?._id,
                game: name,
                score: score.current,
                id: gameId(name, gameName),
                collection: name,
              })
         } else {
            updateGameStorage(name, gameName, point[level], true, level);
            handleUpdateProgress();
         }
         handleTimer();
         setTimeout(()=>handleOpenScore(),animationDurationToShowscoresPopup*1000);
         localStorage.setItem(`${name+'_'+gameName+'_'+level+'_score'}`, score.current);
        }
     }, [rightAnswers]);

    const [hint, setHint] = useState(0);

    useEffect(()=>{
        if (!hintOn) {
            setHint(0);
            return;
        }
        const id = setInterval(()=>setHint(prev=>prev+1), 1000);
        return ()=>clearInterval(id)
    }, [hint, hintOn]);

    return(
        <div className="flex w-full h-full bg-transparent  items-center sm:justify-center z-[30] font-dangrek">
            <div className={`border-[#7643B7] border-collapse xl:border-7px] border-[5px] rounded-[20px] ${getSizes(state)} grid 
               ${level==='beginner' ? 'grid-cols-4': level==='intermediate' ? 'grid-cols-5' : 'grid-cols-6'} `}>
                {
                    result && result.map((item, index)=>{
                        return (
                            <motion.div
                            animate={{x: clickedIndex === index ? [0, -Math.random()*5, Math.random()*5, 0] : [0, 0, 0, 0]}}
                            transition={{duration: animationDurationToShowQWrongAnswer, type: "tween", ease: "linear"}} 
                            onClick={()=>handleClick(item, index)}
                            key={index}
                            style={{
                                border: hintOn && data.current && hint>=10 && hint%2 === 0 && data.current[data.current.indexOf(rightAnswers[rightAnswers.length-1])+1] === item? "2px solid #7643B7": "1px solid #3FA3C8",
                                backgroundImage: !update && !rightAnswers.includes(item) && numbers.current[numbers.current.length-1]===item ? `url(/backGrounds/shulte_segment_bg.svg)` : rightAnswers.includes(item) ? `url(/backGrounds/schulte3_bg_default.svg)` :  `url(/backGrounds/schulte3_bg.svg)`,
                                borderTopLeftRadius: !index && '15px',
                                borderTopRightRadius: (level === 'beginner' && index===3 || level === 'intermediate' && index === 4 || level==='advanced' && index ===5) && '15px',
                                borderBottomLeftRadius: (level === 'beginner' && index===12 || level === 'intermediate' && index===20 || level==='advanced' && index ===30) && '15px',
                                borderBottomRightRadius: (level === 'beginner' && index===15 || level === 'intermediate' && index === 24 || level==='advanced' && index === 35) && '15px',
                                }}
                                className={`text-[20px] ${state ? 'md:text-[20px] lg:text-[24px] xl:text-[36px]' : 'md:text-[24px] lg:text-[32px] xl:text-[45px]'} ${rightAnswers.includes(item) ?  "text-[#529D79]" : 'text-[#FFF]'} relative bg-[position:50%_50%] 
                                ${!update && !rightAnswers.includes(item) && numbers.current[numbers.current.length-1]===item ? "bg-[length:106%_106%]" : "bg-[length:100%_100%]"} bg-no-repeat cursor-pointer flex justify-center items-center  ${getDivSize(state, level)}`}>
                                        {item}
                            </motion.div>
                        )
                    })
                }
            </div>
            {answerSound+""=="true" && <Sound ref={soundRef} url={"/backGrounds/right_answer.wav"} loop={false}/>}
    </div>
    )
}